export const cargaInitialState = {
  esCargaMasiva: true,
  extensionDeArchivosAceptados: 'zip',
  pesoTotalDeArchivos: 0,
  archivos: [],
  mensajeAlerta: '',
  tipoAlerta: '',
  abrirModal: false,
  fecha: '',
  prestador: { nit: '', nombre: '' },
  alfa: '',
  numeroFactura: '',
  pbs: '',
  valor: 0,
  valorConMascara: '',
  loading: false,
  prestadores: [],
}

export default function (state, action) {
  switch (action.type) {
    case 'SET_STATE':
      return { ...state, ...action.payload }
    case 'SET_TIPO_CARGA':
      let nuevoEstado = { ...cargaInitialState, esCargaMasiva: !state.esCargaMasiva }

      if (!state.esCargaMasiva === true) {
        nuevoEstado.extensionDeArchivosAceptados = 'zip'
      } else {
        nuevoEstado.extensionDeArchivosAceptados = ['tiff', 'tif', 'pdf']
      }
      return { ...nuevoEstado }
    case 'RESETEAR_CARGA':
      return {
        ...cargaInitialState,
        esCargaMasiva: state.esCargaMasiva,
        extensionDeArchivosAceptados: state.extensionDeArchivosAceptados,
      }
    case 'SET_ALERT':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
